module.exports = __webpack_public_path__ + "static/media/fullstar.2abe5d30.svg";